/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from '@/plugins'
import "./assets/iconfont/iconfont.js";
import "./assets/iconfont/iconfont.css"
import "./assets/fonts/font.css"

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn'

import './assets/styles/global.css' // 全局样式

// Components
import App from './App.vue'

// Composables
import { createApp } from 'vue'

const app = createApp(App)
app.use(ElementPlus, {
  locale: zhCn,
})
registerPlugins(app)

app.mount('#app')
